import React, { FC } from 'react'
import Box from '@mui/material/Box'

const Filters: FC<React.PropsWithChildren<{
  topButtons?: React.ReactNode,
  filters?: React.ReactNode,
  bottomButtons?: React.ReactNode,
}>> = ({
  topButtons,
  filters,
  bottomButtons,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
      }}
    >
      <Box
        sx={{
          flexGrow: 0,
        }}
      >
        { topButtons }
      </Box>

      <Box
        className="controls"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          //backgroundColor: 'red',
          height: '100%',
          width: '100%',
          py: 1,
          px: 2,
          mt: 1,
          mb: 1,
        }}
      >
        { filters }
      </Box>
      
      <Box
        sx={{
          flexGrow: 0,
          mb: 1,
        }}
      >
        { bottomButtons }
      </Box>
    </Box>
  )
}

export default Filters